module.exports = __webpack_public_path__ + "static/media/mn20.8ce8f30d.jpeg";